export const odsIcons = {
  DeploymentList: "../assets/icon/SVG/connector-check.svg",
  DeploymentSelect: "../assets/icon/SVG/briefcase.svg",
  Home: "../assets/icon/SVG/home.svg",
  Account: "../assets/icon/SVG/account.svg",
  DeviceInfo: "../assets/icon/SVG/configuration.svg",
  Scan: "../assets/icon/SVG/scan.svg",
  Realtime: "../assets/icon/SVG/realtime.svg",
  Vfl: "../assets/icon/SVG/vfl.svg",
  History: "../assets/icon/SVG/scan-report.svg",
  ConnectorCheck: "../assets/icon/SVG/connector-check.svg",
  Aux: "../assets/icon/SVG/aux.svg",
  SorConverter: "../assets/icon/SVG/configuration-empty.svg",
  Monitoring: "../assets/icon/SVG/monitoring.svg",
  MonitoringReset: "../assets/icon/SVG/monitoring.svg",
  MonitoringStop: "../assets/icon/SVG/monitoring-stop.svg",
  StopAll: "../assets/icon/SVG/stop.svg",
  Empty: "../assets/icon/SVG/empty.svg",
  LTE0: "../assets/icon/SVG/lte-0.svg",
  LTE1: "../assets/icon/SVG/lte-1.svg",
  LTE2: "../assets/icon/SVG/lte-2.svg",
  LTE3: "../assets/icon/SVG/lte-3.svg",
} as const;
